export const FontClassToNameMapping = {
  font1: 'Kaushan Script',
  font2: 'Nothing You Could Do',
  font3: 'Caveat',
  font4: 'Fuzzy Bubbles',
};
